import { apiDealTypes, FieldConfig } from 'model/deals.model';
import { useEffect, useState } from 'react';
import { DealsService } from 'service/deals.service';
import BaseDealForm from './BaseDealForm';
import { DYNAMIC_DATA_MAP } from './data';

const DynamicFormSection = ({ dealType }: { dealType: apiDealTypes }) => {
  const data = DYNAMIC_DATA_MAP[dealType];
  const [fields, setFields] = useState<FieldConfig[]>(data);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const dropdownsData = await DealsService.getDealDropdowns(dealType);

        const updatedFields = data.map((field) => {
          if (field.type !== 'select' || !field.name) {
            return field;
          }

          let apiKey = field.name.split('.').pop();

          if (!apiKey) {
            return field;
          }

          if (apiKey === 'stageName') {
            apiKey = 'stages';
          }

          const apiOptions = dropdownsData[apiKey];
          let options: string[] = [];

          if (Array.isArray(apiOptions)) {
            options = apiOptions.map((item: any) =>
              typeof item === 'object' ? item.stageName : item,
            );
          }

          return {
            ...field,
            options: options.length > 0 ? options : field.options,
          };
        });

        setFields(updatedFields);
      } catch (error) {
        console.error('Failed to fetch dropdown values:', error);
        setFields(data);
      }
    };

    fetchDropdowns();
  }, [data, dealType]);

  return <BaseDealForm fields={fields} />;
};

export default DynamicFormSection;
